<script lang="ts">
	import { useAuth0 } from '$lib/auth/auth0';
	import type { RedirectLoginOptions } from '@auth0/auth0-spa-js';
	import { goto } from '$app/navigation';

	export let redirectToHome: boolean = false;

	let { login, isAuthenticated } = useAuth0;

	const loginWithAuth = async () => {
		if ($isAuthenticated) {
			if (redirectToHome) {
				await goto('/home');
			}
			return;
		}

		const options: RedirectLoginOptions = {
			appState: {
				targetUrl: window.location.pathname
			},
			authorizationParams: {
				prompt: 'login'
			}
		};

		await login(options);
	};

	loginWithAuth();
</script>
